import axios from "axios";

const interceptors =  {
  setupAxiosInterceptors: () => {
    axios.interceptors.response.use((response: any) => {
      return response;
    }, (error: any) => {
      if (error.response.status === 401) {
        if (error.config && error.config.url && error.config.url.indexOf('checking_token=true') !== -1) {

        } else {
          localStorage.removeItem('access-token');
          window.location.replace(`${process.env.REACT_APP_AUTHENTICATION_URL}`)
        }
      }

      return Promise.reject(error);
    });
  }
};

export default interceptors;